<template>
  <base-floating-card v-if="event.contactsFetched" @close="close">
    <div
      class="contact-automation-section"
      v-for="contact in event.contacts"
      :key="contact.userId"
    >
      <contact-list-item :contact="contact" />
      <div class="automation-scroller">
        <item-tile
          v-for="(automation, index) in contactTypeAutomations(contact.role)"
          :secondaryIcons="automationIcons(automation, contact)"
          @primary-icon-clicked="toggleAutomationIncluded(automation, contact)"
          @secondary-icon-clicked="
            secondaryIconClicked($event, automation, contact)
          "
          :processing="automation.processing"
          :selected="checkForAutomation(automation, contact)"
          :key="index + contact.userId"
          :text="automation.title"
        />
        <h5 v-if="contactTypeAutomations(contact.role) <= 0">
          No {{ contact.role }} automations. Create some in settings!
        </h5>
      </div>
    </div>
  </base-floating-card>
</template>
<script>
import BaseFloatingCard from "../BaseFloatingCard.vue";
import ContactListItem from "../../ListItems/ListItemComponents/ContactNameAndPhoto.vue";
import ItemTile from "../../ItemTile.vue";
export default {
  data() {
    return {};
  },
  computed: {
    presentContactTypes() {
      let roles = this.contacts.map((x) => {
        return x.role;
      });
      return [...new Set(roles)];
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    contactTypeAutomations(type) {
      let automations = this.$store.getters.automations;
      if (type) {
        return automations.filter((x) => {
          return x.contactType == type;
        });
      } else {
        return [...automations];
      }
    },
    automationIcons(automation, contact) {
      // todo : add preview component and add 'eye-open' to array
      let array = [];
      let findAutomationIndex = this.findAutomationIndex(automation, contact);
      if (findAutomationIndex > -1 && ![][findAutomationIndex].approved) {
        array.push("checkmark");
      }
      return array;
    },
    checkForAutomation(automation, contact) {
      if (this.findAutomationIndex(automation, contact) > -1) {
        return true;
      } else {
        return false;
      }
    },
    findAutomationIndex(automation, contact) {
      return [].findIndex((x) => {
        if (x.configId) {
          if (x.contact_userId) {
            return (
              x.configId === automation.id &&
              x.contact_userId === contact.userId
            );
          } else {
            return x.configId === automation.id && x.contactKey
              ? x.contactKey.userId === contact.userId
              : x.contactId == contact.userId;
          }
        } else {
          if (x.contact_userId) {
            return (
              x.title === automation.title &&
              x.contact_userId === contact.userId
            );
          }
          return x.title === automation.title && x.contactKey
            ? x.contactKey.userId === contact.userId
            : x.contactId === contact.userId;
        }
      });
    },
    async toggleAutomationIncluded(automation, contact) {
      automation.processing = true;
      if (this.checkForAutomation(automation, contact)) {
        let index = this.findAutomationIndex(automation, contact);
        let { id } = [][index];
        let parameters = {
          tenantId: this.event.tenantId,
          automationId: id,
        };
        await this.$store.dispatch("adminDeleteAutomation", parameters);
      } else {
        let payload = {
          contactKey: { userId: contact.userId, tenantId: contact.tenantId },
          event: this.event,
          automation: automation,
        };
        await this.$store.dispatch("addEventAutomation", payload);
      }
      automation.processing = false;
    },
    secondaryIconClicked(icon, automation, contact) {
      switch (icon) {
        case "eye-open":
          this.previewAutomation(automation, contact);
          break;
        case "checkmark":
          this.automationApproved(automation, contact);
          break;
        default:
          break;
      }
    },
    automationApproved(automation, contact) {
      let editIndex = this.findAutomationIndex(automation, contact);
      let subject = [][editIndex];
      this.$store.dispatch("approveAutomation", subject);
    },
  },
  components: {
    BaseFloatingCard,
    ContactListItem,
    ItemTile,
  },
  props: ["event"],
  emits: ["close"],
};
</script>
<style scoped>
.contact-automation-section {
  width: 100%;
}
.automation-scroller {
  display: flex;
  width: 100%;
  overflow: scroll;
  padding: 30px;
}

h5 {
  width: calc(100% - 60px);
  text-align: center;
}
</style>
